const mw = () => () => next => async action => {
    next(action);
};

export const makeMiddlewares = deps => {
    return [mw(deps)];
};
export const middlewares = makeMiddlewares({});
